import { useEffect } from 'react';

import { BankNames } from '@/constants';
import { useAppDispatch, useAppSelector } from '@/store';
import { setInstructionsText } from '@/store/financingStep.slice';

import {
  MAIN_ON_REWORK,
  MAIN_WAITING_INITIAL_PAYMENT,
  MAIN_WAITING_MARRIAGE_DOCUMENTS,
  MAIN_WAITING_REGISTRATION,
  MAIN_WAITING_VEHICLE_REGISTRATION,
  SECONDARY_PAYMENT_STATUS
} from '../features/euras-bank-v2/constants/bank-texts';

interface IProps {
  extrajudicialEnforcementUuid?: string;
}

const ONLINE_REQUEST_STATUSES: string[] = [
  'financed',
  'on_approve_with_fc',
  'on_documents_uploading',
  'on_down_payment_sum_payment',
  'on_in_work_fc',
  'on_pick_up_method_selection',
  'on_sales_department_work',
  'on_signing_dkp'
];

const useInstructionsText = ({ extrajudicialEnforcementUuid }: IProps = {}) => {
  const dispatch = useAppDispatch();
  const { orderApp } = useAppSelector((state) => state.newOrder);
  const { selectedBank } = useAppSelector((state) => state.financingStep);

  useEffect(() => {
    let isSuccess = false;
    let main = '';
    let secondary = '';

    if (orderApp?.isOnlineRequest) {
      const onlineStatusCode = orderApp.onlineClientRequest?.status.code ?? '';
      const onlineStatusName = orderApp.onlineClientRequest?.status.name ?? '';

      if (ONLINE_REQUEST_STATUSES.includes(onlineStatusCode)) {
        isSuccess = onlineStatusCode === 'financed';
        main = isSuccess ? 'Авто выдано' : onlineStatusName;
      }
    } else if (selectedBank?.bankName === BankNames.euBankV2) {
      const statusCode = selectedBank?.status.code ?? '';

      if (statusCode === 'waiting_for_upload_files') {
        main = MAIN_WAITING_REGISTRATION;
      }
      if (!extrajudicialEnforcementUuid) {
        main = MAIN_WAITING_MARRIAGE_DOCUMENTS;
      }
      if (statusCode === 'waiting_for_docs_confirmation') {
        main = '';
      }
      if (statusCode === 'on_rework') {
        main = MAIN_ON_REWORK;
      }
      if (statusCode === 'vehicle_registration') {
        main = MAIN_WAITING_VEHICLE_REGISTRATION;
      }
      if (statusCode === 'mobile_client') {
        main = MAIN_WAITING_INITIAL_PAYMENT;
        secondary = SECONDARY_PAYMENT_STATUS;
      }
    }

    dispatch(setInstructionsText({ isSuccess, main, secondary }));

    return () => {
      dispatch(
        setInstructionsText({ isSuccess: false, main: '', secondary: '' })
      );
    };
  }, [extrajudicialEnforcementUuid, selectedBank?.status.code, orderApp]);
};

export default useInstructionsText;
